// import * as GC from '@grapecity/spread-sheets';
// import * as ExcelIO from '@grapecity/spread-excelio';
import * as XLSX from 'xlsx';
import {AppService} from '../_services/app.service';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Period } from '../models/Period';
import { Cours } from '../models/Cours';
import { Users } from '../models/Users';
import { Results } from '../models/Results';
import { Bulletin } from '../models/Bulletin';
import { Etab } from '../models/Etab';
import { envQNote } from 'src/environments/environment.prod';
import { first } from 'rxjs/internal/operators/first';
import { BaseApp } from '../BaseApp';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { User } from '../models/User';
import { AuthenticationService } from 'src/app/_Services/Authentification.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Categorie } from '../models/Categorie';
import { ItemType } from '../tools-right/ItemType';
import {  Inject, PLATFORM_ID, NgZone } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

interface NoteEntry {
  course: string;
  course_code: string;
  note: number | string;
}

interface StudentNote {
  code_etudiant: string;
  nom_etudiant: string;
  section: string;
  notes: NoteEntry[];
  total: number | string;
  moyenne: number | string;
}

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.css']
})
export class IndexComponent extends BaseApp   implements OnInit {


 // tslint:disable-next-line:max-line-length
  public constructor(
    private route: ActivatedRoute,
    private router: Router,
    private app: AppService,
    private formBuilder: UntypedFormBuilder,
    private auth: AuthenticationService,
    private formBuilder2: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: Object,
    private ngZone: NgZone
  ) {
   super();
   this.CUSER = this.auth.currentUserValueX;
   this.router.routeReuseStrategy.shouldReuseRoute = () => false;
   sessionStorage.setItem('TYPE_APP',"QNOTE");
 }
  get f() {
    return this.loginForm.controls;
  }

  get r() {
    return this.regForm.controls;
  }
  setPage(p: any) {
    this.resMode = p;
    sessionStorage.setItem('PAGE',p);
  }
 CUSER: Users;
 show = '1';
 public period: Period;
 public cours: Cours;
 public cours2: Cours;
 public cats: Categorie;
 public cats_2: Categorie;
 public user: User;
 public bulletin: Bulletin;
 public etab: Etab;
 public tools = true;
 public resMode = 0;
 public loginForm: UntypedFormGroup;
 public regForm: UntypedFormGroup;
 public acad: any;
 public niv: any;
 public fragment: any;
 public  submitted = false;
 public submitted1 = false;
 public token_b = '';
 public periods;
 public clone = true;
 public change_pass =  {password: '', pass_1: '', pass_2: '' };
 public change_name =  {fullName: '', phone :''};
 public change_email = {email: ''};
 public pin;
 setting;
 search = {
  annee: "" ,
  etab_name : "",
  period: "",
  classe: "",
  domain: ''
 }
 setUser(e) {
   this.CUSER = e.user;
   this.period = e.period;
 }

initForm(){

 this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      pass: ['', Validators.required]
    });
    // tslint:disable-next-line:prefer-const
     this.regForm = this.formBuilder2.group({
      fullname: ['', Validators.required],
      etab_name: ['', Validators.required],
      username: ['', Validators.required],
      phone: ['', Validators.required],
      password: ['', Validators.required]
    });

 }

  ngOnInit(): void {
     this.initForm();
     this.getQnoteData();
     if (this.CUSER?.token_user) {
          this.getBulletinData();
     }

     this.token_b = this.route.snapshot.params.token;
     if (this.token_b == '' || this.token_b == null) {
      const period = sessionStorage.getItem('PERIOD_DATA');
      // console.log(period);
      if (period == '' || period == null || period == undefined) {
        this.initData();
        const data = JSON.stringify(this.period);
        sessionStorage.setItem('PERIOD_DATA', data);
      } else {
        this.period = JSON.parse(period);
      }
     } else {
       this.getBulletin();
     }

    let page =sessionStorage.getItem('PAGE');
   // console.log(this.setPage);
    if (page != null && page != undefined) {
        if (parseInt(page) == 2 && this.CUSER!= undefined) {
          page = "0";
          this.setPage(0);
        }
        this.resMode = parseInt(page);
    }
     if (this.resMode<0) {
         this.resMode = 0;
     }
    // console.log(this.resMode);
  }
  getBulletin() {
      this.app.getData(`${envQNote.endpoint}BO/@Bulletin/getBulletinByToken/${this.token_b}`)
      .pipe(first())
      .subscribe(
        data => {
         // console.log(data);
          if (!data.crash) {
            if (data.body.data.DATA != null && data.body.data.DATA != '') {
              this.period = data.body.data.DATA;
             //  console.log(this.period);
              const dataj = JSON.stringify(this.period);
              sessionStorage.setItem('PERIOD_DATA', dataj);
              } else {
               this.router.navigate(['app/tools']);
            }
           }
        }, error => {
           console.log(error);
        }
      );
  }

  pay() {
  }


  saveData() {
    if (this.CUSER.token_user !== '') {
       this.saveBulletin();
       } else {
      this.setPage(2);
    }
  }

  clear() {
    const data = null;
    sessionStorage.setItem('PERIOD_DATA', data);
    this.initData();
    const newData = JSON.stringify(this.period);
    sessionStorage.setItem('PERIOD_DATA', newData);
  }

  newBulletin() {
    const data = null;
    sessionStorage.setItem('PERIOD_DATA', data);
    this.initData();
    const newData = JSON.stringify(this.period);
    sessionStorage.setItem('PERIOD_DATA', newData);
    this.router.navigate(['app/tools']);
  }

  initData() {
    let name = (this.CUSER!=undefined && this.CUSER.etab_name)? this.CUSER.etab_name : "Collège Pledika";
    this.etab =  new Etab('E-1',name, 10, 6, 5.5, 8);
    this.cats =  new Categorie ("Math1", 'Mathematiques', 100, 60, 50, 80, true, true, 2);
    this.cats_2 =  new Categorie ("APP1", 'Applications', 100, 60, 50, 80, false, false,  2);
    this.cours =  new Cours(1, 'Algèbre', 100, 60, 50, 80, true, true, this.cats.code);
    this.cours2 = new Cours(2, 'Absence', 0, 0, 0, 0, false, false, this.cats_2.code);
    this.user = new User('MG-1001', 'Marcella Luc', 'A', true);
    this.bulletin = new Bulletin(this.user, [new Results('R-1', this.cours, 7), new Results('R-2', this.cours2, 2)], 10);
    this.period = new Period('2021-2022', '1er Controle', '1ère Année fondamentale', [this.bulletin], this.etab, [this.cats, this.cats_2]);
    this.period.setOneCours(this.cours);
    this.period.setOneCours(this.cours2);
    this.period.setOneUser(this.user);
  }

  getQnoteData() {
    this.app.getData(`${envQNote.endpoint}BO/@App/home`)
      .pipe(first())
      .subscribe(
        data => {
          if (!data.crash) {
            this.acad = data.body.data.acad;
            this.niv = data.body.data.niveau;
            this.fragment = data.body.data.periode;
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  getBulletinData() {

    this.app.getData(`${envQNote.endpoint}BO/@Bulletin/getDistintSetting`)
    .pipe(first())
    .subscribe(
      data => {
        if (!data.crash) {
                this.setting = data.body.data.DATA;
                console.log(this.setting);
                this.search.etab_name = (this.setting.etab_name.length>0) ? this.setting.etab_name[0].nom_etab : "";
                this.search.annee = (this.setting.year.length>0) ? this.setting.year[0].annee : "";
                this.search.classe = (this.setting.classe.length>0) ? this.setting.classe[0].classe : "";
                this.getAllBulletin();
        }
      },
      error => {
          console.log(error);
      }
    );
  }

  getAllBulletin(){
    const data: FormData = new FormData();
    data.append('etab_name', this.search.etab_name);
    data.append('annee', this.search.annee);
    data.append('classe', this.search.classe);
    data.append('period', this.search.period);
    data.append('domain', this.search.domain);
    let URL = `${envQNote.endpoint}BO/@Bulletin/getBulletinByUserSearch` ;
    this.app.setData(URL, data)
    .pipe(first())
    .subscribe(
      data => {
        if (!data.crash) {
                this.periods = data.body.data.DATA;
        }
      },
      error => {
          console.log("ERROR: ",error);
      }
    );
  }
  onSubmit() {
    // stop here if form is invalid
    if (this.loginForm.invalid) {
      return;
    }

    const email = this.f.email.value;
    const pass = this.f.pass.value;
    const data: FormData = new FormData();
    data.append('email', email);
    data.append('password', pass);
    this.app.setData(`${envQNote.endpoint}BO/@App/login`, data)
      .pipe(first())
      .subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          if (!data.crash) {
            if (!data.body.data.ERROR) {
              this.setAlert('alert-info alert-login', 'Succès',11);
              this.CUSER = data.body.data.DATA;
              this.auth.setUserDataX(data.body.data.DATA);
              this.resMode = 0;
              this.setPage(0);
              this.initForm();
              this.closeAlert();
              this.router.navigate(['app/tools']);
            } else {
              this.setAlert('alert-danger alert-login', data.body.data.MESSAGE, 11);
            }
          } else {
             this.setAlert('alert-danger alert-login', "Serveur non disponible pour le moment.", 11);
          }
        },
        error => {
          console.log(error);
          this.setAlert('alert-danger alert-login', "Serveur non disponible pour le moment.", 11);
        }
      );
  }



  onSubmitReg() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.regForm.invalid) {
       return;
    }
    const email =    this.r.username.value;
    const password = this.r.password.value;
    const fullName = this.r.fullname.value;
    const etab_name = this.r.etab_name.value;
    const phone =    this.r.phone.value;
    const data: FormData = new FormData();
    data.append('email', email);
    data.append('password', password);
    data.append('fullName', fullName);
    data.append('etab_name', etab_name);
    data.append('phone', phone);
    this.app.setData(`${envQNote.endpoint}BO/@App/addUser`, data)
      .pipe(first())
      .subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          console.log(data);
          if (!data.crash) {
            if (!data.body.data.ERROR) {
              this.setAlert('alert-info alert-login', 'Succès', 10);
              this.CUSER = data.body.data.DATA;
              this.auth.setUserDataX(data.body.data.DATA);
              this.setPage(0);
              this.initForm();
              this.closeAlert();
              this.router.navigate(['app/tools']);
            } else {
              this.setAlert('alert-danger alert-login', data.body.data.MESSAGE, 10);
            }
          }
        },
        error => {
          console.log(error);
        }
      );
  }

  logout() {
    this.CUSER = undefined;
    this.periods = [];
    this.setPage(2);
    this.auth.logoutX();
    this.initData();
    const data = JSON.stringify(this.period);
    sessionStorage.setItem('PERIOD_DATA', data);
    this.router.navigate(['app/tools']);
  }
  open(token) {
    if (confirm('Voulez-vous enregistrer ce bulletin ? ')) {
      this.saveBulletinAndNext(token);
    } else {
      this.setPage(0);
      this.router.navigate(['app/tools/'+token]);
    }
  }

  duplicate(token) {
    if (confirm("Voulez-vous vraiment dupliquer ce bulletin scolaire")) {
      if (!this.clone) {
        return;
      }
      this.clone = false;

      this.app.getData(`${envQNote.endpoint}BO/@Bulletin/cloneBulletin/${token}`)
        .pipe(first())
        .subscribe(
          data => {
            if (!data.crash) {
              this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 13);
              sessionStorage.setItem('PERIOD_DATA', null);
              this.getBulletinData();
            } else {
              this.setAlert('alert-danger alert-login', 'Erreur serveur', 13);
            }
            this.clone = true;
          },
          error => {
            console.log(error);
            this.clone = true;
          }
        );
    }
  }

  delBulletin(id) {
      if (confirm('Voulez-vous vraiment supprimer ? ')) {
          this.app.getData(`${envQNote.endpoint}BO/@Bulletin/delBulletin/${id}`)
            .pipe(first())
            .subscribe(
              data => {
                console.log(data);
                if (!data.crash) {
                  this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 13);
                  this.getBulletinData();
                } else {
                    this.setAlert('alert-danger alert-login', 'Erreur serveur', 13);
                }
                this.clone = true;
              },
              error => {
                console.log(error);
                this.clone = true;
              }
            );
      }else{
      this.setAlert('alert-danger alert-login', 'Opération avortée', 13);
      this.router.navigate(['app/tools']);
      }
}


  showProfil() {
    this.setPage(4);
    this.getBulletinData();
  }

  initResults() {
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < this.period.bulletins.length; i++) {
      // tslint:disable-next-line:prefer-for-of
      for (var j = 0; j < this.period.bulletins[i].results.length; j++) {
        if (this.period.bulletins[i].results[j].note) {
          this.period.bulletins[i].results[j].note = null;
        }
      }
    }
  }

   saveBulletinAndNext(token) {
    const json = JSON.stringify(this.period);
    // tslint:disable-next-line:max-line-length
    const data: FormData = new FormData();
    data.append('periode', json );
    this.app.setData(`${envQNote.endpoint}BO/@Bulletin/add`, data)
      .subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          console.log(data);
          if (!data.crash) {
            if (!data.body.data.ERROR) {
                  sessionStorage.setItem('PERIOD_DATA', null);
             } else {
               alert('Erreur Serveur');
            }
            this.setPage(0);
            this.router.navigate(['app/tools/' + token]);
          } else {
            if (data.code == 301 || data.code == '301' ) {
             this.logout();
              this.setPage(2);
            }
          }
        },
        error => {
          console.log(error);
        }
      );
  }
  async saveBulletin() {
    await this.getMoyClasse();
    const json = JSON.stringify(this.period);
    // tslint:disable-next-line:max-line-length
    const data: FormData = new FormData();
    data.append('periode', json);
    data.append('domaine', this.period.etab.domaine);
    this.app.setData(`${envQNote.endpoint}BO/@Bulletin/add`, data)
      .subscribe(
        // tslint:disable-next-line:no-shadowed-variable
        data => {
          if (!data.crash) {
            if (!data.body.data.ERROR) {
              if (this.period.token_b == '' || this.period.token_b == null) {
                 this.router.navigate(['app/tools/' + data.body.data.DATA]);
                 } else {
                  this.period = data.body.data.DATA;
                  const dataj = JSON.stringify(this.period);
                  sessionStorage.setItem('PERIOD_DATA', dataj);
              }
            } else {
               alert('Erreur Serveur ');
            }
          } else {
            if (data.code === 301 || data.code === '301' ) {
             this.logout();
              this.setPage(2);
            }
          }
        },
        error => {
          console.log(error);
        }
      );
  }

   getMoyClasse() {
    // tslint:disable-next-line:prefer-for-of
    let moy = 0;
    this.period.moy_classe = 0
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.period.bulletins.length; i++) {
      // tslint:disable-next-line:prefer-for-of
      let note = 0;
      // tslint:disable-next-line:prefer-for-of
      for (let j = 0; j < this.period.bulletins[i].results.length; j++) {

         if (this.period.bulletins[i].results[j].cours.is_calc && this.period.bulletins[i].results[j].is_calc) {
               note += parseFloat(this.period.bulletins[i].results[j].note);
          }
      }
      const new_moy = (note / this.period.bulletins[i].total_note) * this.period?.etab?.moy_total
      moy  += new_moy ;
      this.period.bulletins[i].student_grad = new_moy;
    }


    this.period.moy_classe = (moy / this.period.bulletins.length);
  }



  changePass() {
    const jdata = JSON.stringify(this.change_pass);
    this.app.setData(`${envQNote.endpoint}BO/@Bulletin/changePass`, jdata)
      .pipe(first())
      .subscribe(
        data => {
          if (!data.crash) {
             this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 14);
          } else if (this.change_pass.pass_1 !== this.change_pass.pass_2) {
            this.setAlert('alert-danger alert-login', 'La confirmation du mot de passe a echoué', 14);
          } else {
              this.setAlert('alert-danger alert-login', 'Erreur serveur', 14);
          }

        },
        error => {
          console.log(error);

        }
      );
  }

  changeName() {
    const jdata: FormData = new FormData();
    jdata.append('fullName', this.CUSER.fullName );
    jdata.append('phone', this.CUSER.phone);
    jdata.append('etab_name', this.CUSER.etab_name);
    this.app.setData(`${envQNote.endpoint}BO/@Bulletin/changeName`, jdata)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          if (!data.crash) {
            this.auth.setUserDataX(this.CUSER);
            this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 15);
          } else {
              this.setAlert('alert-danger alert-login', 'Erreur serveur', 15);
          }
        },
        error => {
          console.log(error);

        }
      );
  }

   changeEmail() {
     this.change_email.email = this.CUSER.email;
     const jdata = JSON.stringify(this.change_email);
     this.app.setData(`${envQNote.endpoint}BO/@Bulletin/changeEmail`, jdata)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          if (!data.crash) {
            this.auth.setUserDataX(this.CUSER);
            this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 16);
          } else {
              this.setAlert('alert-danger alert-login', 'Erreur serveur', 16);
          }

        },
        error => {
          console.log(error);

        }
      );
   }
  validerUser() {
    if (this.pin === this.CUSER.pin) {
       this.app.getData(`${envQNote.endpoint}BO/@Bulletin/valider/${this.pin}`)
      .pipe(first())
      .subscribe(
        data => {
          console.log(data);
          if (!data.crash) {
            this.CUSER.valider_user = 1;
            this.auth.setUserDataX(this.CUSER);
            this.setAlert('alert-info alert-login', data.body.data.MESSAGE, 20);
           } else {
              this.setAlert('alert-danger alert-login', 'Erreur serveur', 20);
          }
        },
        error => {
          console.log(error);
        }
      );
    } else {
     this.setAlert('alert-danger alert-login', 'Pin non valide', 20);
    }
  }

ReformaterRes(){
this.period.bulletins = [];
this.period.users = this.period.users.sort();
this.period.cours = this.period.cours.sort();
this.setNoteToTal();
for (let i = 0; i < this.period.users.length; i++) {
   let r: Results[] = [];
    for (let j = 0; j < this.period.cours.length; j++) {
          let cours  = this.period.cours[j];
          const cr = this.period.annee + '-' + this.period.classe + '-' + this.period.name + '-' + cours.code + '-' + this.period.users[i].code;
           let nr = new Results(cr, cours, '');
          r.push(nr);
    }
    var b  = new Bulletin(this.period.users[i], r, this.period.coef);
    this.period.bulletins.push(b);
  }
}

ReformaterRes2(){
let blt = this.period.bulletins;
this.period.bulletins = [];
this.period.users = this.period.users.sort();
this.period.cours = this.period.cours.sort();
this.setNoteToTal();
for (let i = 0; i < this.period.users.length; i++) {
   let r: Results[] = [];
    for (let j = 0; j < this.period.cours.length; j++) {
          let cours  = this.period.cours[j];
           const cr = this.period.annee + '-' + this.period.classe + '-' + this.period.name + '-' + cours.code + '-' + this.period.users[i].code;
           let note = this.findNoteOfThisBl(blt,this.period.users[i].code,cours,cr);
           let nr = new Results(cr, cours,note);
           r.push(nr);
    }
    var b  = new Bulletin(this.period.users[i], r, this.period.coef);
    this.period.bulletins.push(b);
  }
}

findNoteOfThisBl(bt, cu, cours,cr){
    let note = 0;
    for (let x = 0; x < bt.length; x++) {
      if(bt[x].code && bt[x].code==cu){
        for (let y = 0; y < bt[x].results.length; y++) {
            if(bt[x].results[y].code == cr && bt[x].results[y].note <= cours.note_total){
                 note = bt[x].results[y].note
             }
        }
      }
    }
  return note;
}

setNoteToTal(){
    this.period.coef = 0;
    for (let j = 0; j < this.period.cours.length; j++) {
       let cours  = this.period.cours[j];
      if (cours.is_calc) {
         this.period.coef += cours.note_total;
       }
     }
}

saveItem (e: any) {
     switch(e.type) {
          case ItemType.COURS :
            this.saveNowCours(e.data);
          break;
          case ItemType.CATEGORY :
            this.period.categories.push(e.data);
          break;
          case ItemType.STUDENT :
            this.period.users.push(e.data);
          break;
          case ItemType.A_COURS :
            for (let i = 0; i < e.data.length; i++) {
               this.saveNowCours(e.data[i]);
            }
          break;
          case ItemType.A_CATEGORY :
           this.period.categories = this.period.categories.concat(e.data);
          break;
          case ItemType.A_STUDENT :
            this.period.users = this.period.users.concat(e.data);
          break;
     }
    this.cdr.detectChanges(); // force refresh
     this.saveBulletin();
  }


saveNowCours(cours: any){
     this.period.cours.push(cours);
        // tslint:disable-next-line:prefer-for-of
        for (let i = 0; i < this.period.bulletins.length; i++) {
          // tslint:disable-next-line:max-line-length
          const cr = this.period.annee + '-' + this.period.classe + '-' + this.period.name + '-' + cours.code + '-' + this.period.bulletins[i].user.code;
          const r = new Results(cr, cours, '');
          this.period.bulletins[i].results.push(r);
        }
  }
exportRes: boolean = false;

async exportExcelX() {
  this.exportRes = true;
  // --- SSR/browser guard ---
   if (!isPlatformBrowser(this.platformId)) return; // SSR guard
    let workbook: any | null = null;
    let host: HTMLDivElement | null = null;


  try {

    // Load libs at runtime (avoids tree-shake issues and keeps bundle lean)
    const GCmod = await import('@grapecity/spread-sheets');
    await import('@grapecity/spread-excelio'); // important: side-effect import
    const GC: any = GCmod;

      host = document.createElement('div');
      host.style.position = 'fixed';
      host.style.left = '-10000px';
      host.style.top = '-10000px';
      host.style.width = '1px';
      host.style.height = '1px';
      document.body.appendChild(host);

      // const workbook: any = new GC.Spread.Sheets.Workbook();
      // let sheet =  workbook.getActiveSheet();

       workbook = new GC.Spread.Sheets.Workbook(host, { sheetCount: 1 });
      await new Promise(r => setTimeout(r, 0));
      const ws = new GC.Spread.Sheets.Worksheet('Export');
      console.log(ws);
      workbook.addSheet(0, ws);
      const sheet = ws;
      workbook.setSheetName?.(0, 'Export');


    // === Define positions ===
    const row_code_cat = 0;
    const row_code_cours = 1;
    const row_cours_name = 2;
    const row_coef = 3;
    const start_col = 3;
    const start_col_note = 4;
    const start_row_users = 4;

    let current_col = start_col;

    // === Header Labels ===
    sheet.setValue(row_code_cat, current_col, 'code_categorie_cours');
    sheet.setValue(row_code_cours, current_col, 'code_cours');
    sheet.setValue(row_cours_name, current_col, 'Cours');
    sheet.setValue(row_coef, current_col, 'Coefficient');
    current_col++;

    // === Fill dynamic course columns ===
    for (let i = 0; i < this.period.cours.length; i++) {
      const xcours: Cours = this.period.cours[i];
      sheet.setValue(row_code_cat, current_col, xcours.cat_code);
      sheet.setValue(row_code_cours, current_col, xcours.code);
      sheet.setValue(row_cours_name, current_col, xcours.name);
      sheet.setValue(row_coef, current_col, xcours.note_total);
      current_col++;
    }

    // === Add final columns: Total and Moyenne ===
    sheet.setValue(row_cours_name, current_col, 'Total');
    sheet.setValue(row_cours_name, current_col + 1, 'Moyenne');
    sheet.setValue(row_coef, current_col, this.period.coef);
    sheet.setValue(row_coef, current_col + 1, this.period?.etab?.moy_total);

    // === Student headers ===
    sheet.setValue(start_row_users, 0, 'code_etudiant');
    sheet.setValue(start_row_users, 1, 'nom_etudiant');
    sheet.setValue(start_row_users, 2, 'Section');

    // === Fill student data ===
    let row_cursor = start_row_users + 1;
    for (let j = 0; j < this.period.users.length; j++) {
      const obj: User = this.period.users[j];

      sheet.setValue(row_cursor, 0, obj.code);
      sheet.setValue(row_cursor, 1, obj.name);
      sheet.setValue(row_cursor, 2, obj.section);
      // === Optionally add grades here ===
      const b = this.period.bulletins[j];
      let current_col_note = start_col_note;
      for (let k = 0; k < b.results.length; k++) {
           sheet.setValue(row_cursor, current_col_note, b.results[k].note);
           current_col_note ++;
      }

      row_cursor++;
    }
    // === Export to Excel ===
     const excelIo = new GC.Spread.Excel.IO();
     // const excelIo = new ExcelIO.IO();
    excelIo.save(workbook.toJSON(), (blob: Blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        this.period.annee +
        '_' +
        this.period.classe +
        '_' +
        this.period.name +
        '_results_for_' +
        this.period.classe +
        '.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    });

    this.exportRes = false;
  } catch (e) {
    console.error(e);
    this.exportRes = false;
  }
}

async exportExcel() {
  this.exportRes = true;
  try {
    // Import dynamique (évite les soucis SSR et garde le bundle léger)
    const XLSXmod = await import('xlsx');
    const XLSX: any = XLSXmod;

    // --- mêmes constantes que ton code SpreadJS ---
    const row_code_cat = 0;
    const row_code_cours = 1;
    const row_cours_name = 2;
    const row_coef = 3;
    const start_col = 3;       // colonne D (1-based) => index 3 en 0-based
    const start_col_note = 4;  // colonne E
    const start_row_users = 4; // ligne 5 (0-based)

    // Helper pour remplir un "Array of Arrays" (AOA)
    const aoa: any[][] = [];
    const set = (r: number, c: number, v: any) => {
      if (!aoa[r]) aoa[r] = [];
      aoa[r][c] = v;
    };

    // --- Entêtes cours fixes ---
    let current_col = start_col;
    set(row_code_cat,   current_col, 'code_categorie_cours');
    set(row_code_cours, current_col, 'code_cours');
    set(row_cours_name, current_col, 'Cours');
    set(row_coef,       current_col, 'Coefficient');
    current_col++;

    // --- Colonnes dynamiques pour les cours ---
    for (let i = 0; i < this.period.cours.length; i++) {
      const xcours: Cours = this.period.cours[i];
      set(row_code_cat,   current_col, xcours.cat_code);
      set(row_code_cours, current_col, xcours.code);
      set(row_cours_name, current_col, xcours.name);
      set(row_coef,       current_col, xcours.note_total);
      current_col++;
    }

    // --- Colonnes finales Total / Moyenne ---
    set(row_cours_name, current_col,     'Total');
    set(row_cours_name, current_col + 1, 'Moyenne');
    set(row_coef,       current_col,     this.period?.coef ?? null);
    set(row_coef,       current_col + 1, this.period?.etab?.moy_total ?? null);

    // --- Entêtes élèves ---
    set(start_row_users, 0, 'code_etudiant');
    set(start_row_users, 1, 'nom_etudiant');
    set(start_row_users, 2, 'Section');

    // --- Lignes élèves + notes ---
    let row_cursor = start_row_users + 1;
    for (let j = 0; j < this.period.users.length; j++) {
      const u: User = this.period.users[j];
      set(row_cursor, 0, u.code);
      set(row_cursor, 1, u.name);
      set(row_cursor, 2, u.section);

      const b = this.period.bulletins?.[j];
      let c = start_col_note;
      if (b?.results?.length) {
        for (let k = 0; k < b.results.length; k++) {
          set(row_cursor, c++, b.results[k].note);
        }
      }
      row_cursor++;
    }

    // --- Création de la feuille & du classeur ---
    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // (Optionnel) Largeur de colonnes plus lisibles
    ws['!cols'] = [
      { wch: 16 }, // code_etudiant
      { wch: 24 }, // nom_etudiant
      { wch: 14 }, // Section
      ...Array(Math.max(0, current_col + 2 - 3)).fill({ wch: 14 }) // colonnes cours/notes
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Export');

    // --- Téléchargement ---
    const filename = `${this.period.annee}_${this.period.classe}_${this.period.name}_results_for_${this.period.classe}.xlsx`;
    XLSX.writeFile(wb, filename);
  } catch (e) {
    console.error('exportExcel (xlsx) failed:', e);
  } finally {
    this.exportRes = false;
  }
}



extractNotesFromExcel(file: File): Promise<StudentNote[]> {
  return new Promise((resolve, reject) => {
    const reader: FileReader = new FileReader();

    reader.onload = (e: any) => {
      const data: Uint8Array = new Uint8Array(e.target.result);
      const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });

      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const raw: any = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: '',
      }) as XLSX.AOA2SheetOpts ;
      console.log(raw);
      const headers = raw.slice(0, 4 );     // First 4 rows: headers
      const students = raw.slice(5);       // Student rows start from row 5

      const courseNames: string[] = headers[2].slice(3, -2); // row 3: course names
      const courseCodes: string[] = headers[1].slice(3, -2); // row 2: course codes

      const result: StudentNote[] = [];

      for (let i = 0; i < students.length; i++) {
        const row = students[i];
        const code = row[0];
        const name = row[1];
        const section = row[2];

        if (!code || !name) continue;

        const student: StudentNote = {
          code_etudiant: code,
          nom_etudiant: name,
          section: section,
          notes: [],
          total: row[3 + courseNames.length],
          moyenne: row[4 + courseNames.length],
        };

        for (let j = 1; j < courseNames.length; j++) {
          student.notes.push({
            course: courseNames[j],
            course_code: courseCodes[j],
            note: row[3 + j]
          });
        }
        result.push(student);
      }

      resolve(result);
    };

    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
}
resProc = false;
onFileSelected(event: any) {
  const file = event.target.files[0];
  this.resProc = true;
  if (file) {
    this.extractNotesFromExcel(file).then(notes => {
       this.resProc = false;
      console.log("Extracted notes:", notes);
      this.addResults(notes);
      // You can bind to UI, send to backend, etc.
    }).catch(err => {
      this.resProc = false;
      console.error("Failed to extract notes:", err);
    });
  }
}

addResults(notes: StudentNote[]): void {
  for (const student of notes) {
    for (const entry of student.notes) {
      this.setNote(student.code_etudiant, entry.course_code, entry.note);
    }
  }
  this.saveBulletin();
}

setNote(studentCode: string, courseCode: string, note: any): void {
  const i = this.period.bulletins.findIndex(b => b.user.code === studentCode);
  const bulletin = this.period.bulletins[i];
  if (!bulletin) return;

  const j = bulletin.results.findIndex(r => r.cours.code === courseCode);
  const result = bulletin.results[j]
  if (result) {
    this.period.bulletins[i].results[j].note = note;
  }
}

}


